import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../components/Skeleton/Skeleton";
import {connect} from "react-redux";
import {REQUEST_AWARDS_DATA} from "../../actions/awardsActions";
import ContentPage from "../../components/ContentPage/ContentPage";

const mapStateToProps = state => {
  return {
    awards: state.awardsData
  };
};

const mapDispatchToProps = dispatch => ({
  getAwardsData: () => dispatch({type: REQUEST_AWARDS_DATA})
});


class AwardItem extends Component {
  
  componentDidMount() {
    if (!Object.keys(this.props.awards).length) {
      this.props.getAwardsData();
    }
  };
  
  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        {
          Object.keys(this.props.awards).length ? (
            <ContentPage
              content={this.props.awards}
              arrayName="awards"
              redirectPath="/about/awards"
            />
          ) : <Skeleton type="IFRAME"/>
        }
      </div>
    )
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(AwardItem));



// WEBPACK FOOTER //
// ./src/pages/About/AwardItem.js